// export const apiUri = "https://dev-test.tecno-logica.org";
export const apiUri = "https://www.api.tecno-logica.org";
// export const apiUri = "http://localhost:4000";
